import React from 'react';
import { Star, BadgeCheck, ArrowUpRight, Reply, Trophy } from 'lucide-react';
import { siteConfig, reviews, freelancerStats } from '../data/mock';

const Stars = () => (
  <span className="flex gap-0.5" aria-label="5 out of 5 stars">
    {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#F59E0B] text-[#F59E0B]" />)}
  </span>
);

const ReplyCard = ({ r, i }) => (
  <article
    data-reveal
    style={{ transitionDelay: `${i * 100}ms` }}
    data-testid={`review-card-${r.id}`}
    className="window panel-hover flex flex-col"
  >
    <div className="window-bar !py-2.5">
      <Reply className="w-3.5 h-3.5 text-green" />
      <span className="font-mono text-[11px] text-slate-2 tracking-wider truncate">{r.subject}</span>
      <span className="ml-auto pill pill-green !text-[10px]"><BadgeCheck className="w-3 h-3" /> Verified</span>
    </div>
    <div className="p-6 flex flex-col flex-1">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-11 h-11 rounded-full bg-ink text-white font-display font-bold flex items-center justify-center">{r.initials}</span>
        <div className="leading-tight min-w-0">
          <p className="font-semibold text-ink flex items-center gap-1.5">
            {r.from}
            {r.flag && <img src={r.flag} alt="" className="w-4 h-3 rounded-[2px] object-cover" />}
          </p>
          <p className="text-xs text-slate-2 truncate">{r.role}</p>
        </div>
        <Stars />
      </div>
      <p className="text-ink text-[15px] leading-relaxed">"{r.body}"</p>
      {r.earlier && (
        <div className="mt-4 space-y-2 border-l-2 border-[#E2E8F0] pl-3">
          {r.earlier.map((e) => (
            <p key={e.project} className="text-sm text-slate leading-snug">
              "{e.quote}" <span className="text-slate-2 text-xs">— {e.project}</span>
            </p>
          ))}
        </div>
      )}
      <p className="mt-auto pt-5 font-mono text-[11px] text-slate-2 tracking-wider">{r.meta}</p>
    </div>
  </article>
);

const TestimonialsSection = () => (
  <section id="reviews" className="py-24 lg:py-32 relative" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
        <div className="lg:col-span-7" data-reveal>
          <p className="eyebrow mb-4">Replies received</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-[1.05]">
            A few replies from clients <span className="mark">who came back.</span>
          </h2>
        </div>
        <a
          href={siteConfig.freelancerProfile}
          target="_blank"
          rel="noopener noreferrer"
          data-reveal
          data-testid="reviews-summary-card"
          className="lg:col-span-5 panel panel-hover bg-white p-5 flex items-center gap-5"
        >
          <span className="w-14 h-14 rounded-2xl bg-ink flex items-center justify-center flex-shrink-0"><Trophy className="w-6 h-6 text-[#10B981]" /></span>
          <div className="flex-1 leading-tight">
            <p className="font-semibold text-ink">Preferred Freelancer · {freelancerStats.rank} {freelancerStats.rankOf}</p>
            <p className="text-sm text-slate mt-1">{freelancerStats.rating} ★ across {freelancerStats.reviews} reviews · {freelancerStats.onTime} on time</p>
          </div>
          <ArrowUpRight className="w-5 h-5 text-slate-2" />
        </a>
      </div>

      <div className="grid md:grid-cols-3 gap-5 sm:gap-6">
        {reviews.map((r, i) => <ReplyCard key={r.id} r={r} i={i} />)}
      </div>

      <p className="text-center text-sm text-slate-2 mt-10" data-reveal>
        Hand-picked from verified reviews.{' '}
        <a href={siteConfig.freelancerProfile} target="_blank" rel="noopener noreferrer" className="text-green font-semibold hover:underline" data-testid="reviews-view-all-link">
          Read all {freelancerStats.reviews} on Freelancer.com ↗
        </a>
      </p>
    </div>
  </section>
);

export default TestimonialsSection;
